import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

import { IconButtonProps } from 'types/icon';
import { useTranslation } from 'react-i18next';

const CampaignExportButton: React.FC<IconButtonProps> = ({ onClick }) => {
    const { t } = useTranslation();
    return (
        <Button
            onClick={onClick}
            variant="contained"
            size="large"
            sx={{
                textTransform: 'none',
                width: '177px',
                height: '60px',
                borderRadius: '39px',
                padding: '0px',
            }}
        >
            <Box
                component={'div'}
                width={'100%'}
                height={'100%'}
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '11px',
                }}
            >
                <FileDownloadOutlinedIcon
                    sx={{ fontSize: '40px !important', color: 'inherit' }}
                />
                <Typography
                    fontSize={20}
                    component={'span'}
                    fontWeight={'bold'}
                    lineHeight={'24px'}
                >
                    {t('page.campaign.button.export')}
                </Typography>
            </Box>
        </Button>
    );
};

export default CampaignExportButton;
